<template>
  <div class='user-content'>
    <div class="menu-list">
      <div v-for="(item,index) in menuList" :key="index">
        <div class="menu-item"><i class='iconfont' :class="item.icon"></i>{{lang==1?item.title:item.title_en}}</div>
        <div v-for="(val,key) in item.list" :key="key">
          <router-link v-if='!val.languageID'
                       class="menu-item-router" tag="div"
                       :to="{path:`${val.url}?u=${userdef16}&showdetailsid=${showdetailsid}&exh=${exh}`}">
            {{lang==1?val.text:val.text_en}}
          </router-link>
          <router-link v-else-if='val.languageID && val.languageID==lang'
                       class="menu-item-router" tag="div"
                       :to="{path:`${val.url}?u=${userdef16}&showdetailsid=${showdetailsid}&exh=${exh}`}">
            {{lang==1?val.text:val.text_en}}
          </router-link>
        </div>
      </div>
      <div class='menu-item login-out' @click="loginOutEvent"><i class='iconfont icon-tuichu icon20'></i>{{lang==1?'退出登录':'Logout'}}</div>
    </div>
    <transition name="fade-transform" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
    import {mapState} from 'vuex'
    import { menuList } from "@/common/data";
    import { getUserdef16,removeUserdef16,removeToken} from '@/utils/cookieinfo'
    export default {
        name: 'user',
        data() {
          return {
            menuList: menuList,
            exh: this.$route.query.exh || "",
            showdetailsid: this.$route.query.showdetailsid || "",
            userdef16: this.$route.query.u || "",
          }
        },
        computed: {
          ...mapState(['lang'])
        },
        methods: {
          goPage() {
            var query = {
              showdetailsid: this.showdetailsid,
              exh: this.exh
            };
            this.$router.push({
              name: "login",
              query: query
            });
          },
          loginOutEvent() {
            console.log(this.lang)
              this.$confirm(this.$t('common.makeSure'), {
                confirmButtonText: this.$t('common.ok'),
                cancelButtonText: this.$t('common.cancel'),
                center: true
              }).then(() => {
                removeUserdef16()
                removeToken()
                this.goPage()
              }).catch( err => {
                console.log(err)
              })
          }
        }
    }
</script>

<style lang="less" scoped>
.menu-list {
  min-width: 200px;
  max-height: 700px;
  background: #F0F3EF;
}
.menu-item {
  font-size: 15px;
  color: @color;
  padding: 15px 0 15px 30px;
  font-weight: bold;
  cursor: pointer;
}
.menu-item:hover,.menu-item-router:hover {
  background-color: rgb(192, 194, 191);
  transition: background-color 0.5s;
}
.menu-item-router {
  height: 50px;
  line-height: 50px;
  padding-left: 62px;
  cursor: pointer;
  color: #474747;
  font-size: 14px;
  white-space: nowrap;

}
.router-link-active {
  background: @theme-color;
  color: #ffffff;
}

.router-link-active:hover {
  background: @theme-color;
  color: #ffffff;
}

.user-content {
  display: flex;
  width: 100%;
  box-sizing: border-box;
}
.sub-content {
  width: calc( 100% - 200px );
}
.login-out {
  cursor: pointer;
}
.iconfont {
  font-size: 22px;
  vertical-align: middle;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue